<template>
  <div class="pie-chart-container">
          
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" small>
                    fas fa-info-circle
                  </v-icon>
                </template>
                <p style="text-align: left" class="mb-0">
                  <strong>Note:</strong> "Amer. Indian" = American Indian/Alaska Native;<br />"Nat.
                  Hawaiian" = Native Hawaiian/Other Pacific Islander<br />
                  <em>Percentages may not total 100% due to rounding.</em>
                </p>
              </v-tooltip>&nbsp;<i class="hover-hint text-body-2" v-if="!this.$store.getters.isMobile"
      >Hover over charts for population %s:</i>

    <p class="text-body-2-small"><em>Race reflects people reporting a single race, not of Hispanic origin, on the 2020 Census questionnaire. Hispanic can be of any race.</em></p>

    <v-card elevation="1" class="chart-holder" outlined tile>
      <div class="chart-container">
        <div
          class="pie-chart-div"
          id="tot-chart-container"
          :ref="this.legBody + 'totChartContainer'"
        >
          <span class="chart-title"> Total Population </span>
          <i
            id="totPercent"
            v-if="!this.$store.getters.isMobile"
            class="chart-pct"
            >Hover over legend to highlight chart</i
          >
        </div>
        <div
          class="pie-chart-div"
          id="vap-chart-container"
          :ref="this.legBody + 'vapChartContainer'"
        >
          <span class="chart-title"> Voting Age (VAP) </span>
          <i
            id="vapPercent"
            v-if="!this.$store.getters.isMobile"
            class="chart-pct"
            >Hover over legend to highlight chart</i
          >
        </div>
      </div>
      <div class="legend">
        <div class="column-1">
          <span
            @mouseover="mouseOver(i)"
            @mouseleave="mouseLeave(i)"
            v-for="(l, i) in legendColumnOne"
            :key="i"
            class="legend-item"
          >
            <span
              class="swatch"
              :style="{
                backgroundColor: l.color,
                border: `0px solid ${l.color}`,
              }"
            ></span>
            {{ l.name }}
            <div class="print-only">
              VAP: {{ vapArray[i].pct }}% Total: {{ totArray[i].pct }}%
            </div>
          </span>
        </div>
        <div class="column-2">
          <span
            @mouseover="mouseOver(i + 4)"
            @mouseleave="mouseLeave(i + 4)"
            v-for="(l, i) in legendColumnTwo"
            :key="i"
            class="legend-item"
          >
            <span
              class="swatch"
              :style="{
                backgroundColor: l.color,
                border: `0px solid ${l.color}`,
              }"
            ></span>
            {{ l.name }}
            <div class="print-only">
              VAP: {{ vapArray[i].pct }}% Total: {{ totArray[i].pct }}%
            </div>
          </span>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import * as d3 from "d3";

export default {
  name: "PieChart",
  props: ["districtData", "legBody", "side"],
  components: {},
  mounted: function () {
    //this.demoArrayManager = Config.dataArrayManager;
    this.buildPie("tot");
    this.buildPie("vap");
  },
  methods: {
    calculatePercents: function (popType) {
      //console.log(popType)
      let totPop = +this.postgresDataObj[`${popType === 'tot' ? 'totpop20' : 'vaptotal20'}`]

      // this.districtArray.forEach((element) => {
      //   if (!isNaN(element.value)) {
      //     totPop += +element.value;
      //   }
      // });


      this.districtArray.forEach((element) => {
        //console.log(element.value)
       // console.log(totPop)
        element["pct"] = ((+element.value / totPop) * 100).toFixed(1);
      });
    },
    buildPie: function (popType) {
      this.$refs[`${this.legBody}${popType}ChartContainer`].innerHTML = `
      <span class='chart-title'> ${
        popType === "tot" ? "Total Population" : "Voting Age (VAP)"
      } </span>

     
      <i id="${popType}-${
        this.side
      }-Percent" class="chart-pct">Hover over legend to highlight chart</i>
      `;

      //console.log(`${popType}Percent`)

      this.districtArray = [
        //Colors from CUR Visualizing a Changing Region 2010
        {
          name: "Hispanic",
          value: +this.postgresDataObj[`${popType}hisp20`] || 0,
          color: "#31A353", //#914200
        },
        {
          name: "White non-Hispanic",
          value: +this.postgresDataObj[`${popType}whitenh20`] || 0,
          color: "#6CAFD6", //#005757
        },
        {
          name: "Asian",
          value: +this.postgresDataObj[`${popType}asiannh20`] || 0,
          color: "#C10F83", //#E34848
        },
        {
          name: "Black",
          value: +this.postgresDataObj[`${popType}blacknh20`] || 0,
          color: "#E6560E", //#E38E48
        },
        {
          name: "Amer. Indian",
          value: +this.postgresDataObj[`${popType}aiannh20`] || 0,
          color: "#756BB1", //#b3de69
        },
        {
          name: "Nat. Hawaiian",
          value: +this.postgresDataObj[`${popType}nathawnh20`] || 0,
          color: "#969696", //#fdb462
        },
        {
          name: "Other/multiple race",
          value: +this.postgresDataObj[`${popType}othernh20`] || 0,
          color: "#fdb462", //#007400
        },
      ];

      this[`${popType}Array`] = this.districtArray;

      this.calculatePercents(popType);

      const width = 150;
      const height = 100;

      //const color =
      d3.scaleOrdinal()
        .domain(this.districtArray.map((d) => d.value))
        .range(
          d3
            .quantize(
              (t) => d3.interpolateSpectral(t * 0.8 + 0.1),
              this.districtArray.length
            )
            .reverse()
        );

      const arcs = d3
        .pie()
        .value(function (d) {
          return d.value;
        })
        .sort(null)(this.districtArray);

      const self = this;
      let tooltip;
      if (popType === "tot") {
        this.totTooltip =
          this.totTooltip ||
          d3
            .select("body")
            .append("div")
            .style("position", "absolute")
            .classed("tooltip", true)
            .style("z-index", "10")
            .style("visibility", "hidden")
            .style("background", "#fffd");
        tooltip = this.totTooltip;
      }

      if (popType === "vap") {
        this.vapTooltip =
          this.vapTooltip ||
          d3
            .select("body")
            .append("div")
            .style("position", "absolute")
            .classed("tooltip", true)
            .style("z-index", "10")
            .style("visibility", "hidden")
            .style("background", "#fffd");
        tooltip = this.vapTooltip;
      }

      const svg = d3
        .select(self.$refs[`${this.legBody}${popType}ChartContainer`])
        .append("svg")
        .attr("viewBox", [-width / 2, -height / 2, width, height]);

      this[`${popType}SVG`] = svg;

      svg
        .append("g")
        .selectAll("path")
        .data(arcs)
        .join("path")
        .attr("fill", (d) => d.data.color)
        .on("mouseenter", function (d, i) {
          tooltip.text(
            `${i.data.name}: \r\n ${i.data.pct}% ${
              popType === "tot" ? "(Total Pop.)" : "(VAP)"
            }`
          );
          return tooltip.style("visibility", "visible");
        })
        .on("mousemove", function (e) {
          return tooltip
            .style("top", e.clientY - 10 + "px")
            .style("left", e.clientX + 10 + "px")
            .style("visibility", "visible");
        })
        .on("mouseleave", function () {
          return tooltip.style("visibility", "hidden");
        })
        .attr(
          "d",
          d3
            .arc()
            .innerRadius(25)
            .outerRadius(width / 3 - 1)
        );
    },
    mouseOver: function (i) {
      let self = this;
      this["totSVG"]
        .selectAll("g")
        .selectAll("path")
        .filter(function (d, j) {
          if (j === i) {
            document.getElementById(
              `tot-${self.side}-Percent`
            ).innerText = `${d.data.name}: ${d.data.pct}%`;
          }
          return j === i;
        })
        .classed("outline-show", true);

      this["vapSVG"]
        .selectAll("g")
        .selectAll("path")
        .filter(function (d, j) {
          if (j === i) {
            document.getElementById(
              `vap-${self.side}-Percent`
            ).innerText = `${d.data.name}: ${d.data.pct}%`;
          }
          return j === i;
        })
        .classed("outline-show", true);
    },
    mouseLeave: function (i) {
      let self = this;
      document.getElementById(`vap-${self.side}-Percent`).innerText =
        "Hover over legend to highlight chart";

      document.getElementById(`tot-${self.side}-Percent`).innerText =
        "Hover over legend to highlight chart";
      this["totSVG"]
        .selectAll("g")
        .selectAll("path")
        .filter(function (d, j) {
          return j === i;
        })
        .classed("outline-show", false);

      this["vapSVG"]
        .selectAll("g")
        .selectAll("path")
        .filter(function (d, j) {
          return j === i;
        })
        .classed("outline-show", false);
    },
  },
  watch: {
    postgresDataObj: function () {
      this.buildPie("tot");
      this.buildPie("vap");
    },
  },
  computed: {
    postgresDataObj: function () {
      return this.districtData;
    },

    activeDistrictType: function () {
      return this.$store.getters.getActiveDistrictType;
    },

    legendColumnOne: function () {
      return this.districtArray.slice(
        0,
        Math.round(this.districtArray.length / 2)
      );
    },

    legendColumnTwo: function () {
      return this.districtArray.slice(
        Math.round(this.districtArray.length / 2),
        this.districtArray.length
      );
    },
  },
  data: function () {
    return {
      districtArray: [],
      hover: {},
      totArray: [],
      vapArray: [],
      totSVG: null,
      vapSVG: null,
      totPercent: 0,
      vapPercent: 0,
      totTooltip: null,
      vapTooltip: null,
    };
  },
};
</script>
<style scoped>
.pie-chart-container {
  width: 100%;
}

.pie-chart-div {
  width: 50%;
  padding: 5px;
  display: inline-block;
}

div .legend span {
  display: block;

  margin-right: 5px;

  /* border: 1px solid darkgrey; */
  /* border: 1px solid rgb(253, 253, 253); */
  opacity: 0.9;
}

.chart-holder {
  padding: 0 5px;
  margin: 5px 0px;
  background-color: #fff7 !important;
}
.legend {
  /* font-size: 0.9em; */
  font-size: 0.7em;
  display: inline-block;
  width: 100%;
  padding: 1%;
  border-top: 1px solid #80808030;
}

.column-1,
.column-2 {
  width: 48%;
  display: inline-block;
  /* font-size: .9em; */
  position: initial;
}

.column-1 span,
.column-2 span {
  cursor: default !important;
}

.column-2 {
  position: absolute;
}
.swatch {
  /* width: 15px; */
  width: 12px;
  height: 12px;
  display: inline-block !important;
}

#vap-chart-container {
  border-left: 1px solid #d3d3d352;
}

#tot-chart-container {
  border-right: 1px solid #d3d3d352;
}
</style>
<style>
.tooltip {
  padding: 10px;
  border-radius: 4px;
  font-family: "Roboto", Tahoma, sans-serif;
}
.chart-title {
  font-weight: bold;
  font-size: 0.9em;
  text-align: center;
  width: 100%;
  display: inline-block;
}

.hover-hint {
  color: gray;
}

.chart-pct {
  color: gray;
  /* max-height: 10px; */
  /* font-size: 0.9em; */
  font-size: 0.8em;
  height: 38px;
  display: block;
  line-height: 1.4;
}

.outline-show {
  stroke: #000000;
  stroke-width: 3px;
  stroke-linejoin: round;
}

.legend-item:hover {
  background-color: lightgray;
  border-radius: 0;
}

.print-only,
#print-container .hover-hint,
#print-container .chart-pct {
  display: none;
}

#print-container .print-only {
  display: block;
  border-bottom: 1px solid lightgrey;
  padding: 10px 0px;
  margin-bottom: 10px;
}
</style>